import React from "react";

/**
 * MissionBadge
 * ──────────────────────────────────────────────────────────────
 * A small NASA-style bracketed pill that announces system status.
 *
 *   <MissionBadge>MISSION ACTIVE</MissionBadge>
 *   <MissionBadge tone="mission">LIVE · 0942 UTC</MissionBadge>
 *   <MissionBadge tone="warn">SUB-NOMINAL</MissionBadge>
 *   <MissionBadge tone="alert">CRITICAL HOLD</MissionBadge>
 *
 * Props:
 *   tone:   "accent" | "mission" | "warn" | "alert"   (default: accent)
 *   icon:   optional small icon node placed before the dot
 */
export default function MissionBadge({ tone = "accent", icon, children, className = "", ...rest }) {
  const toneClass =
    tone === "mission" ? "nasa-badge--mission" :
    tone === "warn"    ? "nasa-badge--warn"    :
    tone === "alert"   ? "nasa-badge--alert"   : "";
  return (
    <span
      className={`nasa-badge ${toneClass} ${className}`.trim()}
      data-testid="nasa-mission-badge"
      {...rest}
    >
      {icon}
      {children}
    </span>
  );
}
